import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {AuthProvider} from './AuthContext';
import LoginPage from './LoginPage';
import ProtectedRoute from './ProtectedRoute';
import DashboardsOverview from './DashboardsOverview';
import Home from './Home';
import DataSourcePage from './DataSourcePage';
import AddNewConnection from './AddNewConnection';
import DataSourcesList from './DataSourcesList';
import DocumentsListPage from './DocumentsListPage';
import document from './documents';
import DocumentDetail from './DocumentDetail';
import Prometheus from './AddPrometheus';
import MySQL from './AddMySQL';
import Layout from './Layout';
import DashboardNewPanel from './DashboardNewPanel';
import UserPanel from './UserPanel';
import AdministrationPage from './Administration';
import ForgotPassword from './ForgotPassword';
import ResetPasswordPage from './ResetPasswordPage';
import FolderDashboards from './FolderDashboards';
import DashboardDetail from './DashboardDetail';
import NewSnmpCredential from './NewSnmpCredential';
import AlertsPage from './alertspage';
import MediaConfigForm from './MediaConfig';
import SnmpOIDManager from './SnmpMetricConfigurator';
import MappingConfig from './ValueMapping';
import ApiSourceForm from './ApiSourceForm';
import MetricConfigTabs from './MetricConfigTabs';
import PermissionsPage from './PermissionsPage';
import TenantForm from './TenantForm';
import AdminLoginPage from './AdminLoginPage';
import IPWhitelistForm from './IPWhitelistForm';
import ChangePasswordPage from './ChangePasswordPage';
import UserPage from './UserPage';
import TenantMetricValueQueries from './TenantMetricValueQueries';
import ProbeListPage from './ProbeListPage';

// Ping Log Pages
import PingLogListPage from './PingLogListPage';
import PingLogDetailPage from './PingLogDetailPage';
import PingLogAggregatedDetailPage from './PingLogAggregatedDetailPage';
import ZabbixDataSourcePage from "./ZabbixDataSourcePage";
import APIKeyPage from "./APIKeyPage";
import HTTPGatewayPage from "./HTTPGatewayPage";

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Public Routes */}
                    <Route path="/login" element={<LoginPage/>}/>
                    <Route path="/login/admin" element={<AdminLoginPage/>}/>
                    <Route path="/forgot-password" element={<ForgotPassword/>}/>
                    <Route path="/reset-password/:token" element={<ResetPasswordPage/>}/>

                    {/* Protected Routes */}
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout/>
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Home/>}/>

                        <Route path="user" element={<UserPage/>}>
                            <Route path="change-password" element={<ChangePasswordPage/>}/>
                        </Route>

                        {/* Data Source Routes */}
                        <Route path="data-source" element={<DataSourcePage/>}>
                            <Route path="add-new-connection" element={<AddNewConnection/>}/>
                            <Route path="add-new-connection/prometheus" element={<Prometheus/>}/>
                            <Route path="add-new-connection/mysql" element={<MySQL/>}/>
                            <Route path="data-sources-list" element={<DataSourcesList/>}/>
                        </Route>

                        {/* Dashboard Routes */}
                        <Route path="dashboard" element={<DashboardsOverview/>}/>
                        <Route path="dashboard/create" element={<DashboardNewPanel/>}/>
                        <Route path="dashboard/query_value" element={<TenantMetricValueQueries/>}/>
                        <Route path="dashboard/folder/:name" element={<FolderDashboards/>}/>
                        <Route path="dashboard/details/:dashboardName" element={<DashboardDetail/>}/>

                        {/* Ping Log Routes */}
                        <Route path="pinglog" element={<PingLogListPage/>}/>
                        <Route path="pinglog/aggregated-detail" element={<PingLogAggregatedDetailPage/>}/>
                        <Route path="pinglog/:logId" element={<PingLogDetailPage/>}/>

                        {/* Documentation Routes */}
                        <Route path="documentation" element={<DocumentsListPage documents={document}/>}>
                            <Route path=":title" element={<DocumentDetail documents={document}/>}/>
                        </Route>

                        {/* Administration Routes */}
                        <Route path="administration" element={<AdministrationPage/>}>
                            <Route path="users" element={<UserPanel/>}/>
                            <Route path="ip-whitelist" element={<IPWhitelistForm/>}/>
                            <Route path="permissions" element={<PermissionsPage/>}/>
                            <Route path="tenant" element={<TenantForm/>}/>
                        </Route>

                        {/* Alerts Routes */}
                        <Route path="alerts" element={<AlertsPage/>}>
                            <Route path="media" element={<MediaConfigForm/>}/>
                            <Route path="snmpoid-manager" element={<SnmpOIDManager/>}/>
                            <Route path="SnmpCredential" element={<NewSnmpCredential/>}/>
                            <Route path="value-mapping" element={<MappingConfig/>}/>
                            <Route path="probe-manager" element={<ProbeListPage/>}/>
                            <Route path="apisource-config" element={<ApiSourceForm/>}/>
                            <Route path="zabbix-data-sources" element={<ZabbixDataSourcePage/>}/>
                            <Route path="api-keys" element={<APIKeyPage/>}/>
                            <Route path="metrics-config" element={<MetricConfigTabs/>}/>
                            <Route path="/alerts/http-gateway" element={<HTTPGatewayPage/>} />
                        </Route>
                    </Route>
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;